import { DYNAMIC_REPEATER_ROLE } from '@wix/wix-data-client-common-standalone'

import type { Logger } from '../logger'
import { Breadcrumb } from '../logger'
import { AdaptedComponent } from '../inverted-dependencies/components/componentFactory'
import { AdaptedDynamicRepeaterComponent } from '../inverted-dependencies/components/dynamicRepeaterAdapter'
import { canLoadMoreItems, getCurrentPageIndex } from '../helpers/paginationUtils'

import { StateSideEffectSubscriberFactory } from './types'

export const syncDynamicRepeatersWithStateFactory: StateSideEffectSubscriberFactory = ({
  store: { getState },
  logger,
  recordStore,
  datasetId,
  components,
}) => {
  const dynamicRepeaters = components.filter(isAdaptedDynamicRepeaterComponent)

  if (dynamicRepeaters.length === 0) {
    return
  }

  return () => {
    const state = getState()

    const pageIndex = getCurrentPageIndex({ state })
    const canLoadMore = canLoadMoreItems({ state, recordStore })

    const singlePage = pageIndex === 1 && !canLoadMore

    for (const { id: repeaterId, loadMoreButton } of dynamicRepeaters) {
      if (singlePage) {
        if (loadMoreButton.visible) {
          loadMoreButton.hide()
          logLoadMoreButtonVisibleChanged(logger, datasetId, repeaterId, false)
        }
      } else {
        if (loadMoreButton.hidden) {
          loadMoreButton.show()
          logLoadMoreButtonVisibleChanged(logger, datasetId, repeaterId, true)
        }

        if (loadMoreButton.enabled === canLoadMore) {
          continue
        }

        if (canLoadMore) {
          loadMoreButton.enable()
        } else {
          loadMoreButton.disable()
        }

        logLoadMoreButtonEnabledChanged(logger, datasetId, repeaterId, canLoadMore)
      }
    }
  }
}

function isAdaptedDynamicRepeaterComponent(
  component: AdaptedComponent,
): component is AdaptedDynamicRepeaterComponent {
  return component.role === DYNAMIC_REPEATER_ROLE
}

function logLoadMoreButtonVisibleChanged(
  logger: Logger,
  datasetId: string,
  componentId: string,
  visible: boolean,
) {
  logger.log(
    new Breadcrumb({
      category: 'components',
      message: `${componentId} loadMoreButton state changed to ${visible ? 'visible' : 'hidden'} (dataset: ${datasetId})`,
    }),
  )
}

function logLoadMoreButtonEnabledChanged(
  logger: Logger,
  datasetId: string,
  componentId: string,
  enabled: boolean,
) {
  logger.log(
    new Breadcrumb({
      category: 'components',
      message: `${componentId} loadMoreButton state changed to ${enabled ? 'enabled' : 'disabled'} (dataset: ${datasetId})`,
    }),
  )
}
